import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ToolsType } from '../../models/layoutClass';

import './SidePanel.scss';
import { selectToolAction } from '../../redux/layout/layoutActions';
import { GraphicsTools } from './GraphicsTools';
import { HostChatTool } from './chat/HostChatTool';
import Settings from './settings/Settings';
import { Polls } from './polls/Polls';
import { PublicChatTool } from './chat/PublicChatTool';
import { QnA } from './qna/QnA';
import PeopleRoster from './PeopleRoster';

import { container } from 'tsyringe';
import { WebRTCsdkService } from '../../services/webrtcsdk-service';


const SidePanel = () => {

  const layout: any = useSelector((state: any) => state.layout);
  const dispatch = useDispatch();

  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));

  const closeTool = () => {
    dispatch(selectToolAction(ToolsType.NONE));
  }

  useEffect(() => {
    // if in SETTINGS , then let Settings.tab decide
    if (layout.selectedTool !== ToolsType.SETTINGS) {
      webRTCsdkService.settingsCameraVisible = false;
    }
  }, [layout.selectedTool])


  return (
    <section className={'tool ' + (layout.selectedTool === ToolsType.NONE ? 'collapsed' : '')}>
      {
        (layout.selectedTool !== ToolsType.NONE) &&
        <>
          <div className="tool-name">
            {layout.selectedTool}
            <div className="tool-close" onClick={closeTool}></div>
          </div>
          {
            (layout.selectedTool === ToolsType.GRAPHICS) &&
            <div id="graphicsPanelREF" className="toolbar" key={layout.selectedTool}>
              <GraphicsTools></GraphicsTools>
            </div>
          }
          {
            (layout.selectedTool === ToolsType.HOSTCHAT) &&
            <div className="toolbar" key={layout.selectedTool}>
              <HostChatTool></HostChatTool>
            </div>
          }
          {(layout.selectedTool === ToolsType.CHAT) &&
            <div className="toolbar" key={layout.selectedTool}>
              <PublicChatTool></PublicChatTool>
            </div>
          }
          {
            (layout.selectedTool === ToolsType.PEOPLE) &&
            <div className="toolbar" key={layout.selectedTool}>
              <PeopleRoster></PeopleRoster>
            </div>
          }
          {
            (layout.selectedTool === ToolsType.SETTINGS) &&
            <div className="toolbar" key={layout.selectedTool}>
              <Settings></Settings>
            </div>
          }
          {
            (layout.selectedTool === ToolsType.POLL) &&
            <div className="toolbar" key={layout.selectedTool}>
              <Polls></Polls>
            </div>
          }
          {
            (layout.selectedTool === ToolsType.QA) &&
            <div className="toolbar" key={layout.selectedTool}>
              <QnA></QnA>
            </div>
          }
        </>
      }

    </section>
  );
}

export default SidePanel;